<mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ label | translate }}</mat-label>
    <textarea matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            [formControlName]="fieldName"
            [cdkAutosizeMinRows]="minRows"
            [cdkAutosizeMaxRows]="maxRows"
    ></textarea>
    
    <mat-error *ngIf="getFormControlField()?.hasError('required')">
        {{ 'data-table.modal.validation-error.field-required' | translate }}
    </mat-error>
        
    <mat-error *ngIf="getFormControlField()?.hasError('length')">
        {{ 'data-table.modal.validation-error.exact-length' | translate : { length: getFormControlField()?.getError('length')['requiredLength'] } }}
    </mat-error>
    
    <mat-error *ngIf="getFormControlField()?.hasError('maxlength')">
        {{ 'data-table.modal.validation-error.max-length' | translate : { maxLength: getFormControlField()?.getError('maxlength')['requiredLength'] } }}
    </mat-error>
</mat-form-field>